.region {
  position: fixed;
  left: 50%;
  top: calc(var(--safe-t) + 14px);
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(92vw, 420px);
  pointer-events: none;
}

.toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--r-md);
  background: rgb(28 28 31 / 0.92);
  backdrop-filter: blur(16px);
  border: 1px solid var(--border-strong);
  box-shadow: var(--shadow-lg);
  font-size: var(--fs-sm);
  font-weight: 600;
  animation: bb-fade-in var(--t-med) var(--ease);
}

.error {
  border-color: rgb(255 77 94 / 0.5);
}

.success {
  border-color: rgb(var(--accent-rgb) / 0.5);
}

.action {
  color: var(--accent);
  font-weight: 700;
  white-space: nowrap;
}
